function appendGalleryCaptions() {
  const galleryItems = document.querySelectorAll(".av-horizontal-gallery-wrap");

  galleryItems.forEach((galleryItem) => {
    const image = galleryItem.querySelector("img");
    const title = image?.getAttribute("title")?.trim();

    if (!title || galleryItem.querySelector(".h-gal-caption")) {
      return;
    }

    const caption = document.createElement("span");
    caption.className = "h-gal-caption";
    caption.textContent = title;
    galleryItem.append(caption);
  });
}

export { appendGalleryCaptions };
